import { render, staticRenderFns } from "./PaginatedSingleCardGroupList.vue?vue&type=template&id=328d9b0c"
import script from "./PaginatedSingleCardGroupList.vue?vue&type=script&lang=js"
export * from "./PaginatedSingleCardGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports